const taskRecordStatuses = {
  active: { id: 'active', name: 'No' },
  archived: { id: 'archived', name: 'Yes' },
};

export default taskRecordStatuses;
